import React from 'react'
import { Container } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';
import BOTManagementContainer from '../components/BackOfficeTechnology/BOTManagementContainer';

class BOTManagement extends React.Component {

  render() {
    return (<Container fluid>
      <BOTManagementContainer {...this.props} />
    </Container>
    );
  }
}

export default BOTManagement;